export enum AnnouncementStatusCodes {
    Announced = 'N',
    Confirmed = 'P',
    Rejected = 'S',
    Cancelled = 'Z'
}
